<template>
    <div>
        <mt-header :title="title"></mt-header>
        <h3 style="    color: rgb(0, 0, 0);
    padding: 20px;
    line-height: 31px;">{{marketInfo.title}}</h3>
        <div style="padding: 20px;" v-html="marketInfo.content"></div>

        <div v-for="item in marketInfo.uploadFileList" style="color: black;padding: 20px;height: auto;width: 100%;">
            <div style="    border: 1px ridge rgb(177, 174, 170);
    width: 100%;
    height: 40px;
    line-height: 40px;
    padding: 4px;" @click="fileDownload(item)">
                <i class="fa fa-file-pdf-o fa-2x"></i><span style="    margin-left: 29px;
    cursor: pointer;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-top: -45px;">{{item.fileName}}</span></div>
        </div>

    </div>
</template>

<script>
    import "mint-ui/lib/style.css";
    import { Header } from 'mint-ui';
    import {queryWechatMarketInfoById,queryWechatInfo1ById,queryWechatInfo2ById} from '../../api/api';
    import axios from 'axios';

    export default {
        data() {
            //驗證登錄名字
            return {
                marketInfo:{},
                content:[],
                markInfoId:null,
                type:null,
                toDate:null,
                insuredName:"",
                ownerName:"",
                statusOption:[
                    //狀態, 0:處理中, 1:存檔, 2: 終止申請, 3. 冷靜期退保, 4: 生效, 5:轉出保單, 6: 保單失效
                    {label:'處理中',value:0},{label:'存檔',value:1},{label:'終止申請',value:2},{label:'冷靜期退保',value:3},
                    {label:'生效',value:4},{label:'轉出保單',value:5},{label:'保單失效',value:6},{label:'擱置',value:7}
                    ,{label:'拒保',value:8},{label:'廢除',value:9}
                ],
                statusStr:"",
                statusDesc:"",
                title:""
            }
        },
        methods: {
            fileDownload(file){
                if(file.id!=null && file.id!='' && file.id!=undefined){
                    window.location.href=axios.defaults.baseURL+'/file/download/?id='+file.id;
                }
            },
            queryWechatMarketInfoById(){
                    return queryWechatMarketInfoById(this.markInfoId).then(res=>{
                        if(res.errcode==200){
                            this.marketInfo = res.data;
                        }else{
                            this.$message.error(res.errmsg);
                        }
                    }).catch((error)=>{
                        console.log("queryWechatMarketInfoById Error");
                    });
                },
            queryWechatInfo1ById(){
                return queryWechatInfo1ById(this.markInfoId).then(res=>{
                    if(res.errcode==200){
                        this.marketInfo = res.data;
                    }else{
                        this.$message.error(res.errmsg);
                    }
                }).catch((error)=>{
                    console.log("queryWechatMarketInfoById Error");
                });
            },
            queryWechatInfo2ById(){
                return queryWechatInfo2ById(this.markInfoId).then(res=>{
                    if(res.errcode==200){
                        this.marketInfo = res.data;
                    }else{
                        this.$message.error(res.errmsg);
                    }
                }).catch((error)=>{
                    console.log("queryWechatMarketInfoById Error");
                });
            }
        },
        mounted() {
            this.markInfoId=this.$route.query.id;
            this.type=this.$route.query.type;
            if(this.type==null){
                this.queryWechatMarketInfoById();
                this.title="市場資料";
            }else if(this.type==1){
                this.queryWechatMarketInfoById();
                this.title="市場資料";
            }else if(this.type==2){
                this.queryWechatInfo1ById();
                this.title="肺炎資訊1";
            }else if(this.type==3){
                this.queryWechatInfo2ById();
                this.title="肺炎資訊2";
            }

        },
        computed: {

        },
        activated(){

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/wechat/WechatMarketInfo.vue